module.exports = __webpack_public_path__ + "static/footer-bg-001a6145a8e35634c381056d806fa329.svg";